import React from 'react';

const ImageSkeleton = () => {
  const skeletonStyles = {
    skeleton: {
      background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
      backgroundSize: '200% 100%',
      animation: 'loading 1.5s infinite',
    }
  };
  return (
    <div className="col-md-6">
      <div className="uploaded-card skeleton">
        <div className="upladed-imgdescription">
          <div
            className="card-uploadimages skeleton-image"
            style={{
              ...skeletonStyles.skeleton,
              width: '150px',
              height: '150px',
              borderRadius: '8px'
            }}
          />
          <div>
            <div className="form-inputdropDiv mb-2">
              <div
                className="skeleton-text"
                style={{
                  ...skeletonStyles.skeleton,
                  width: '60px',
                  height: '16px',
                  marginBottom: '4px'
                }}
              />
              <div
                className="form-control form-control-sm skeleton-input"
                style={{
                  ...skeletonStyles.skeleton,
                  width: '100px',
                  height: '32px',
                  border: 'none'
                }}
              />
            </div>
            <div className="form-inputdropDiv mb-3">
              <div
                className="skeleton-text"
                style={{
                  ...skeletonStyles.skeleton,
                  width: '60px',
                  height: '16px',
                  marginBottom: '4px'
                }}
              />
              <div
                className="form-control form-control-sm skeleton-input"
                style={{
                  ...skeletonStyles.skeleton,
                  width: '100px',
                  height: '32px',
                  border: 'none'
                }}
              />
            </div>
            <div className="form-check">
              <div
                className="skeleton-checkbox"
                style={{
                  ...skeletonStyles.skeleton,
                  width: '120px',
                  height: '20px',
                  borderRadius: '4px'
                }}
              />
            </div>
            <div className="form-inputdropDiv mb-2">
              <div
                className="skeleton-dpi"
                style={{
                  ...skeletonStyles.skeleton,
                  width: '80px',
                  height: '25px',
                  borderRadius: '4px'
                }}
              />
            </div>
          </div>
        </div>
        <div className="add-removeimgDiv">
          <div className="incdescrse-count skeleton-quantity">
            <div style={{ display: 'flex', gap: '8px' }}>
              <div
                style={{
                  ...skeletonStyles.skeleton,
                  width: '30px',
                  height: '30px',
                  borderRadius: '4px'
                }}
              />
              <div
                style={{
                  ...skeletonStyles.skeleton,
                  width: '50px',
                  height: '30px',
                  borderRadius: '4px'
                }}
              />
              <div
                style={{
                  ...skeletonStyles.skeleton,
                  width: '30px',
                  height: '30px',
                  borderRadius: '4px'
                }}
              />
            </div>
          </div>
          <div className="dupli-removebtnDiv">
            <div
              className="skeleton-button"
              style={{
                ...skeletonStyles.skeleton,
                width: '100px',
                height: '36px',
                borderRadius: '4px',
                marginRight: '8px'
              }}
            />
            <div
              className="skeleton-button"
              style={{
                ...skeletonStyles.skeleton,
                width: '100px',
                height: '36px',
                borderRadius: '4px'
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageSkeleton;
